import React from "react";
import { Button, Card, CardHeader } from "reactstrap";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { Table, TableRow } from "../../../components/Table";
import {
    showToaster,
    TRA_FILTER,
    TRA_PAGINATION_OPTIONS,
} from "../../../constant";
import { useAutoRefreshTime, useRole } from "../../../redux/slices/authSlice";
import { Active_Merchant_Payout_PG } from "../../../redux/slices/payinPayoutSlice";
import { useLocation } from "react-router-dom";
import useAutoRefresh from "../../../components/useAutoRefresh";
import CopyToClipboard from "react-copy-to-clipboard";
import ActiveMerchantPGModal from "../../../components/Custom/Modals/ActiveMerchantPG/ActiveMerchantPGModal";

const ActiveMerchantPayout = () => {
    const [filterColumns, setFilterColumns] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [viewData, setViewData] = useState(false);
    const [filter, setFilter] = useState(TRA_FILTER);
    const role = useRole("Active Merchant Pg");
    const autoRefreshTime = useAutoRefreshTime();
    const location = useLocation()?.pathname?.split?.("/");
    const { updateRefreshTime } = useAutoRefresh(location?.at(-1));
    const dispatch = useDispatch();

    const { getActiveMerchantPayoutPGState } = useSelector(
        (state) => state.payinPayout
    );
    const columns = [
        {
            title: "Merchant Name",
            name: "merchantName",
        },
        {
            title: "Label",
            name: "pg_label",
            Cell: ({ pg_label }) => {
                if (!pg_label || typeof pg_label !== "object") return null;

                return (
                    <div style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                        {Object?.entries?.(pg_label || {})?.map?.(
                            ([pgKey, labels], index) => (
                                <div key={index}>
                                    <strong>{pgKey} : </strong>{" "}
                                    {Array.isArray?.(labels) ? labels?.join?.(", ") : labels}
                                </div>
                            )
                        )}
                    </div>
                );
            },
        },
        {
            title: "Action",
            name: "Action",
            Cell: (val) => {
                return (
                    <Button
                        className="submitTransbutton"
                        onClick={() => {
                            setViewData(val);
                        }}
                    >
                        Details
                    </Button>
                );
            },
        },
    ];

    const ongetActiveMerchantPayoutPG = async () => {
        try {
            setIsLoading(true);
            const payload = {
                ...filter,
            };
            await dispatch(Active_Merchant_Payout_PG(payload)).unwrap();
            setIsLoading(false);
        } catch (err) {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        const newColumns = columns?.map((item) => item?.name);
        setFilterColumns(newColumns);
    }, []);

    useEffect(() => {
        if (role.includes("activeMerchantPayoutPg-list")) {
            ongetActiveMerchantPayoutPG();
        }
    }, [filter]);

    useEffect(() => {
        const IntervalClick = setInterval(() => {
            if (refresh) {
                ongetActiveMerchantPayoutPG();
            }
        }, autoRefreshTime);
        return () => clearInterval(IntervalClick);
    }, [refresh, filter]);

    const prepareCopyContent = (data) => {
        let temp = [];
        if (data && data?.length > 0) {
            temp = data?.map?.((dt) => {
                if (!dt?.merchantName || !dt?.pg_label) return "";

                let content = `--- ${dt?.merchantName} ---`;
                Object.entries?.(dt?.pg_label || {})?.forEach?.(([pg, labels]) => {
                    const labelStr = Array?.isArray?.(labels)
                        ? labels?.join?.(", ")
                        : labels;
                    content += `\n  ${pg}: ${labelStr}`;
                });
                return content;
            });
        }

        return temp?.join?.("\n\n")?.trim();
    };

    if (!role.includes("activeMerchantPayoutPg-list")) {
        return;
    }

    return (
        <>
            {role.includes("activeMerchantPayoutPg-list") ? (
                <div
                    className={`payoutmanual-main-div ${isLoading && refresh ? "opacity-25" : ""
                        }`}
                >
                    <Card>
                        <CardHeader>
                            <div className="d-flex align-items-center w-100 justify-content-end">
                                <div className="d-flex gap-1">
                                    <CopyToClipboard
                                        text={prepareCopyContent(
                                            Object.values?.(
                                                getActiveMerchantPayoutPGState?.data || {}
                                            )
                                        )}
                                    >
                                        <Button
                                            className={"filterbtn"}
                                            disabled={
                                                !Object.keys?.(
                                                    getActiveMerchantPayoutPGState?.data || {}
                                                )?.length || isLoading
                                            }
                                            onClick={(e) => {
                                                showToaster("Copied");
                                            }}
                                        >
                                            Copy
                                        </Button>
                                    </CopyToClipboard>
                                    <Button
                                        type="button"
                                        className={`${refresh ? "" : "filterbtn"} gap`}
                                        color={refresh ? "primary" : ""}
                                        onClick={() => {
                                            setRefresh(!refresh);
                                            if (!refresh) {
                                                updateRefreshTime();
                                            }
                                        }}
                                        title="Auto refresh"
                                    >
                                        {refresh ? (
                                            <i className="fa-solid fa-arrows-rotate  rotate-animation"></i>
                                        ) : (
                                            <i className="fa-solid fa-arrows-rotate"></i>
                                        )}
                                        Auto Refresh
                                    </Button>
                                </div>
                            </div>
                        </CardHeader>
                        <Table
                            columns={columns}
                            filterColumns={filterColumns}
                            isLoading={isLoading && !refresh}
                            data={
                                !!Object.values?.(
                                    getActiveMerchantPayoutPGState?.data || {}
                                ) || []
                            }
                            isData={
                                !!Object.keys?.(getActiveMerchantPayoutPGState?.data || {})
                                    ?.length
                            }
                            count={getActiveMerchantPayoutPGState?.total_item || 0}
                            pagination={filter}
                            isExpandable={false}
                            handlePaginationChange={(pagination) => {
                                setFilter({
                                    ...filter,
                                    ...pagination,
                                });
                            }}
                            onColumnsChange={(columns) => {
                                setFilterColumns(columns);
                            }}
                            paginationOptions={TRA_PAGINATION_OPTIONS}
                        >
                            {Object.values?.(
                                getActiveMerchantPayoutPGState?.data || {}
                            )?.map?.((item) => {
                                return (
                                    <TableRow
                                        columns={columns}
                                        filterColumns={filterColumns}
                                        item={item}
                                        isExpandable={false}
                                    />
                                );
                            })}
                        </Table>
                    </Card>
                </div>
            ) : null}
            <ActiveMerchantPGModal
                data={viewData}
                isViewsendDataModal={viewData}
                onCloseModal={() => {
                    setViewData(false);
                }}
            />
        </>
    );
};

export default ActiveMerchantPayout;
